<div style="display: flex;flex-direction: column; gap: 20px;width: 100%;">
    <div class="job-card-skeleton" style="width: 100%;" *ngFor="let item of [1,2,3,4,5]">
        <div class="card-main-content">
            <div class="card-content">
                <div class="skeleton title"></div>
                <div class="skeleton posted-by"></div>
                <div class="skeleton-group">
                    <div class="skeleton location"></div>
                    <div class="skeleton salary"></div>
                    <div class="skeleton job-type"></div>
                </div>
            </div>
        </div>
        <div class="buttons">
            <div class="skeleton button"></div>
            <div class="skeleton button"></div>
        </div>
    </div>
</div>